var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "canvas::editor-admin-ModeAndViewportToolbar shrink-0" },
    [
      _c(
        "div",
        { staticClass: "relative z-0 inline-flex shadow-sm rounded-md ml-10" },
        [
          _c(
            "button",
            {
              staticClass:
                "relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500",
              class: {
                "bg-indigo-50 border-indigo-200": _vm.activeMode === "overview",
              },
              attrs: {
                type: "button",
                title: "Bekijk en bewerk de content vanaf een afstand.",
              },
              on: { click: _vm.onOverviewClick },
            },
            [
              _c("i", { staticClass: "far fa-search-minus mr-2" }),
              _vm._v(" "),
              _c("span", [_vm._v("Overzicht")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "-ml-px relative inline-flex items-center px-4 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500",
              class: {
                "bg-indigo-50 border-indigo-200": _vm.activeMode === "content",
              },
              attrs: {
                type: "button",
                title: "Bewerk de individuele blokken op detailniveau.",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("update:activeMode", "content")
                },
              },
            },
            [
              _c("i", { staticClass: "far fa-pencil mr-2" }),
              _vm._v(" "),
              _c("span", [_vm._v("Content")]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "relative z-0 inline-flex shadow-sm rounded-md ml-10" },
        _vm._l(_vm.viewports, function (viewport, id, key) {
          return _c(
            "button",
            {
              staticClass:
                "-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500",
              class: {
                "bg-indigo-50 border-indigo-200": _vm.activeViewport === id,
                "rounded-r-md": key === Object.keys(_vm.viewports).length - 1,
                "rounded-l-md": key === 0,
              },
              attrs: { type: "button", title: viewport.title },
              on: {
                click: function ($event) {
                  return _vm.setActiveViewport(id)
                },
              },
            },
            [_c("i", { staticClass: "far fa-fw", class: viewport.icon })]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }